module.exports = __webpack_public_path__ + "img/01.9230bd66.jpg";